import { AppMessages } from 'i18n/messages';

export const isTranslationAvailable = (message: string): message is keyof typeof AppMessages => {
  return message in AppMessages;
};
